import React from "react";
import { Box, Grow } from "@mui/material";
import { SmsRounded, WhatsApp } from "@mui/icons-material";
// import {
//   Message,
//   MessageImage,
// } from "../../../../Chat/components/chat-elements/components";
// import useStyles from '../styles';
import bgChat from "../../../../../../assets/dashboard/backChat.jpg";
import {
  AvatarMobile,
  ContentMobile,
  ContentTopBar,
  IPhoneContent,
  TopBar,
} from "../../styles";
import Message from "../Message/intex";
import MessageImage from "../MessageImage";

interface PhoneProps {
  isWhatsapp?: boolean;
  isStatusWhatsapp?: boolean;
  data: any;
}

export default function Phone({
  isWhatsapp,
  isStatusWhatsapp,
  data,
}: PhoneProps) {
  // const classes = useStyles(),

  const chat = {
    i_send: 1,
    message: data?.whatsapp_midia ? data?.whatsapp_url : data?.mensagem,
    caption: data?.mensagem,
    data_envio: data?.data_envio && data?.data_envio?.replace("Z", ""),
  };

  return (
    <Grow in>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <IPhoneContent
          // className={classes.contentIphone}
          sx={{
            backgroundColor: isStatusWhatsapp ? "#000" : "#FFF",
            backgroundSize: isStatusWhatsapp ? "contain" : "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundImage: isStatusWhatsapp
              ? `url(${data.whatsapp_url})`
              : isWhatsapp
              ? `url(${bgChat})`
              : "transparent",
          }}
        >
          <ul
            style={{
              border: "none",
              margin: "0 0 16px 0",
              padding: 0,
            }}
          >
            <li
              style={{
                backgroundColor: isStatusWhatsapp ? "transparent" : "#F6F6F6",
                height: "6vh",
                listStyle: "none",
                borderRadius: "20px 20px 0 0",
              }}
              // className={classes.btnVolune}
            >
              <Box display="flex" alignItems="center" padding="2vh 1vw 0">
                <AvatarMobile>
                  {/* className={classes.avatarMobile} */}
                  {isWhatsapp || isStatusWhatsapp ? (
                    <WhatsApp style={{ fontSize: "12pt" }} />
                  ) : (
                    <SmsRounded style={{ fontSize: "12pt" }} />
                  )}
                </AvatarMobile>
                &nbsp;
                <b
                  style={{
                    fontSize: "9pt",
                    color: isStatusWhatsapp ? "#FFF" : "#000",
                  }}
                >
                  {isStatusWhatsapp
                    ? "Meus status"
                    : isWhatsapp
                    ? "Whatsapp"
                    : "SMS"}
                </b>
              </Box>
            </li>
          </ul>

          <TopBar>
            {/* className={classes.topbar} */}
            <ContentTopBar />
            {/* className={classes.contentTopbar} */}
          </TopBar>

          <ContentMobile
            onClick={() => isStatusWhatsapp && window.open(data.whatsapp_url)}
            style={{ cursor: isStatusWhatsapp ? "pointer" : "" }}
            display={isStatusWhatsapp ? "flex" : "initial"}
            alignItems="flex-end"
            justifyContent="center"
            height={isStatusWhatsapp ? "85%" : "auto"}
            // className={classes.contentMobile}
          >
            {isStatusWhatsapp ? (
              <Box color="#FFF" textAlign="center">
                <span>{data?.mensagem}</span>
              </Box>
            ) : data?.whatsapp_midia ? (
              <MessageImage
                item={chat}
                onClick={() => window.open(data?.whatsapp_url)}
              />
            ) : (
              <Message item={chat} />
            )}
          </ContentMobile>
        </IPhoneContent>
      </Box>
    </Grow>
  );
}
